// import { getFramework } from '@/framework';
import { getReferenceLinesState } from '../states/reference-lines-state';

// import { ReferenceLineHistoryType } from '../types';

export class LockReferenceLines {
    constructor(private id: string) {}

    lock(lock: boolean, pushHistory = true) {
        getReferenceLinesState(this.id).setLockReferenceLines(lock);

        // ATTENTION: 当前的产品方案控制参考线的显示隐藏不需要写入历史记录
        // 写入历史记录
        // if (pushHistory) {
        //     const framework = getFramework(this.id);
        //     framework.service.history.write({
        //         type: ReferenceLineHistoryType.LOCK,
        //         data: { lock },
        //     });
        // }
    }
}
